import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent'
import { DataTable } from '@/components/ui/DataTable'
import { Button } from '@/components/shadcn/button'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { useRestClient } from '@/contexts/QueryProvider'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { Suspense } from 'react'
import { ApplicationSettingForm } from '../Forms/ApplicationSettingForm'
import { ApplicationsBreadcrumb } from '../ApplicationsBreadcrumbs'
import { useCurrentApplication } from '../useCurrentApplication'
import { appSettingsTableColumns } from './AppSettingsTable/appSettingsTableColumns'

export const AppSettingsPage = () => {
  return (
    <>
      <ApplicationsBreadcrumb title="Settings" />
      <QueryErrorBoundary errorMessage="Failed to fetch application settings">
        <Suspense fallback={<DataTableLoading />}>
          <AppSettingsPageContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function AppSettingsPageContent() {
  const { applicationId } = useCurrentApplication()
  const { getApplicationsApiGetApplicationSettings } = useRestClient()
  const { data: settings } = getApplicationsApiGetApplicationSettings.useSuspenseQuery({
    query: { applicationId },
  })

  return (
    <TablePageContainer>
      <DataTable
        columns={appSettingsTableColumns}
        data={settings ?? []}
        action={
          <ApplicationSettingForm
            sheetTitle="Add setting"
            sheetTrigger={
              <Button size="sm" variant="outline">
                <IconPlusOutline className="mr-2" />
                Add setting
              </Button>
            }
          />
        }
      />
    </TablePageContainer>
  )
}
